import React, { useState, useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/services/Errores";
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import DialogoQueryClientesLayout from "./layouts/DialogoQueryClientesLayout";
import QueryClienteReducer     from "../reductores/QueryClienteReducer";
import BuscarClientes from "../reductores/acciones/dispatch/BuscarClientes";
import CargaDeClientesBuscados from "../reductores/acciones/dispatch/CargaDeClientesBuscados";
import FinalizarComando        from "../reductores/acciones/dispatch/FinalizarComando";
import ServiceQueryClientes    from "../../isp.žapi.clientes/ServiceQueryClientes";

// import { NotificacionToastDeError } from "../../../all/componentes/widgets/Notificaciones";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

// import ServicioDeQueryDeUnClienteAFacturar from "../../servicios/ServicioDeQueryDeUnClienteAFacturar";

const DialogoQueryClientes = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryClienteReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    // const buscarClientesAFacturar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    const buscarClientesAFacturar = async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */
        dispatchQ(new BuscarClientes());

        try {
            const respuestaQuery = await new ServiceQueryClientes().ejecutar(paramsQuery);
            dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoQueryClientesLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarClientesAFacturar={buscarClientesAFacturar}
        />
    );
};

export default DialogoQueryClientes;
